import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { UiRadioWrappedDirective } from '@ui';

@Component({
  selector: 'sbnb-add-task-rule-flow-task-type',
  standalone: true,
  imports: [CommonModule, MatRadioModule, UiRadioWrappedDirective],
  templateUrl: './add-task-rule-flow-task-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTaskRuleFlowTaskTypeComponent {
  selectedTaskType = signal<string | null>(null);
  taskTypeSelected = output<string>();

  onTaskTypeChange(value: string): void {
    this.selectedTaskType.set(value);
    this.taskTypeSelected.emit(value);
  }

  readonly taskTypes = [
    {
      value: 'cleaning',
      label: 'Cleaning',
      description: 'For turnovers and periodic deep cleans.',
    },
    {
      value: 'check-in',
      label: 'Check-in',
      description: 'For admin, inventory, or other tasks before check-in.',
    },
    {
      value: 'checkout',
      label: 'Checkout',
      description: 'For admin, inventory, or other tasks after checkout.',
    },
    {
      value: 'maintenance',
      label: 'Maintenance',
      description: 'For repairs, inspections, and routine upkeep.',
    },
  ];
}
